import React from 'react';
import Title from '../../Components/Formatting/Customer/Title';
import Subtitle from '../../Components/Formatting/Customer/Subtitle';
import Balance from '../../Components/Formatting/Customer/Balance';
import Search from './Search';
import { useSearch } from '../../Components/Search';
import { Link } from 'react-router-dom';
import { getEntityLink, plural } from '../../Services/helpers';
import NoItems from '../../Components/EmptyStates/NoItems';

const List = ({customers, isEmpty, isLoading, setAddingCustomer}) => {
    const {hasActiveSearch, liveSearch} = useSearch();

    return <>
        <Search isLoading={isLoading} />

        {isEmpty && <p className="text-center text-muted text-sm mt-8">
            {hasActiveSearch ? 'No customers match your current search' : <NoItems icon="Users" title="Add your first customer" onClick={() => setAddingCustomer(true)} />}
        </p>}

        <ul className="divide-y divide-gray-200">
            {customers.filter(liveSearch).map(c => <Item key={c.id} customer={c} />)}
        </ul>
    </>
}

const Item = ({customer}) => {
    return <li className="flex items-center justify-between gap-x-6 py-5">
        <Link to={getEntityLink('Customers/Customer', customer.id)} className="w-full block">
            <div className="min-w-0">
                <div className="flex items-start gap-x-3">
                    <p className="text-gray-900">
                        <Title className="font-semibold" customer={customer} />
                        <br />
                        <Subtitle customer={customer} />
                    </p>
                </div>
                <div className="mt-1 flex items-center gap-x-2 text-gray-500">
                    <p className="whitespace-nowrap">
                        <Balance customer={customer} />
                    </p>

                    <p className="text-red-600 ml-3">
                        {plural(customer.unreadMessages, null, '1 Message', `${customer.unreadMessages} Messages`)}
                    </p>
                </div>
            </div>
        </Link>
        <div className="flex flex-none items-center gap-x-4">
            {/* <Dropdown options={[]} /> */}
        </div>
    </li>
}

export default List;
